import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Эсперанто и Интернет… 
        Как удачно сопоставлены эти два слова! 
        Оба они обозначают универсальные средства общения, объединяющие все человечество. 
        Одно из них существует около 120 лет; другое – около 30. 
        Но можно сказать, что Эсперанто жил в ожидании Интернета, который сделал его поистине интернациональным.
      </p>

      <p class="mb-3">
        В самом деле, много ли людей может себе позволить разъезжать по конгрессам, семинарам, встречам, 
        лагерям отдыха эсперантистов, которые происходят практически каждый день? 
        Ведь в среднем, за 1 месяц в мире проводится около 20 эсперантских мероприятий. 
        Встречи бывают на любой вкус, от нудистских до семейных; хотя, пожалуй, это не разнообразие, а звенья одной цепи: 
        должны же будущие родители где-то познакомиться! 
        (Я знаю одну семью, в которой уже 5 поколений подряд рождаются эсперантисты, воспитанные эсперантистами-родителями). 
        Но в большинстве, кто все-таки ездит? 
        Студенты да пенсионеры; нам мешают визы и деньги, «богатым капиталистам» - работа 
        (они в самом деле живут не так, как мы, потому что не так работают).
      </p>

      <p class="mb-3">
        Что остается? 
        Правильно, переписка. 
        Живое, непосредственное общение в Интернете (не на бумажке же! 
        Я недавно посылала письмо в город Чебоксары; спросила, сколько оно будет идти. 
        Сказали, месяц-полтора. Наверное, мешки с почтой пешком носят…). 
        По данным <a href="https://netributes.com/stats/" target="_blank">netributes.com/stats/</a>, 
        предпочитаемый язык общения в Сети для 41,68% опрошенных – Эсперанто (для сравнения: 45,33% - английский; 
        далее с огромным отрывом: испанский – 3,11%, русский – 1,93%, остальные языки (всего указано 15 языков) – менее, 
        чем по 1% опрошенных.
      </p>

      <p class="mb-3">
        Что же делают эсперантисты в Интернете? 
        А много чего. 
        Например, существует такой многоязычный проект, как Википедия, или свободно редактируемая сетевая энциклопедия Wikipedia 
        (<a href="https://eo.wikipedia.org" target="_blank">eo.wikipedia.org</a>). 
        Его разработка началась в 2001 году на английском языке. 
        В 2002 г. началось создание статей на языке Эсперанто. 
        Эсперанто-версию инициировали Chuck Smith, Brian Wibber и Stefano Kalbo. 
        На начало 2004 года в этой энциклопедии насчитывалось более 350 000 статей; из них 10 106 на Эсперанто, 
        который занимает 10-ое место по распространенности среди всех языков, на которых создаётся Википедия 
        (на сегодняшний момент более 40).
      </p>

      <p class="mb-3">
        Принципы, на которых строится Википедия – нейтральность точки зрения на предмет 
        (что абсолютно соответствует принципиальной нейтральности языка Эсперанто), 
        принцип copyleft на основе GFDL и GPL (доступность информации), 
        развитая система ссылок и связей (так, с zoologio на Эсперанто можно перейти на Zoologie на немецком языке, 
        zoology на английском, зоология на русском и т.д.) 
        Согласно данным поисковика Alexa(<a href="https://alexa.com" target="_blank">alexa.com</a>), 
        многоязычная Википедия принадлежит к тысяче наиболее посещаемых сайтов мира.
      </p>

      <p class="mb-3">
        В 2002 году образовалось и другое объединение разработчиков Эсперанто-сайтов: 
        международная молодежная группа «Эсперанто и Интернет» (E@I). 
        В её составе – представители Литвы, Швеции, Сербии, Израиля, Словакии, Франции… 
        У них единый язык, язык взаимопонимания – Эсперанто. 
        В результате регулярной работы этой группы создано несколько крупных Эсперанто-сайтов: 
        <a href="https://lingvo.info" target="_blank">Lingva Prismo</a>, 
        <a href="https://lernu.net" target="_blank">lernu!</a>, 
        <a href="https://interkulturo.net" target="_blank">Interkulturo</a>.
      </p>

      <p class="mb-3">
        Каждый из них интересен по-своему. 
        Lingva Prismo, например – это многоязычный Интернет-проект для интересующихся языковыми проблемами современного мира; 
        lernu! – интерактивный учебный курс с упражнениями и играми; 
        Interkulturo – сайт международного проекта «Интеркультура», 
        посвященный различным аспектам взаимодействия представителей разных культур и стран. 
        Ведь именно эсперантисты на своих конгрессах и встречах (да и в Интернете!) постоянно общаются друг с другом, и то, 
        что в одной культуре допустимо, в другой может оказаться шокирующим и неприличным. 
        В рамках проекта образуются рабочие группы, которые обсуждают какую-либо тему, например, «Сказки», «Застольные традиции», 
        «Приветствия», в своей среде, а затем обмениваются результатами с аналогичными группами из других стран. 
        Так и происходит… ну, скажем, ликвидация «интеркультурной безграмотности», что очень многим из нас просто необходимо.
      </p>

      <p class="mb-3">
        Сайт <a href="https://edukado.net" target="_blank">edukado.net</a>, созданный при финансовой поддержке фонда 
        Esperantic Studies Foundation, объединяет преподавателей языка эсперанто, предоставляя им свежую методическую информацию, 
        возможность общаться на форуме, а также богатейшую коллекцию учебных материалов разного уровня: 
        упражнения, игр, скороговорок, экзаменационных материалов…
      </p>

      <p class="mb-3">
        В Брюсселе, где, как известно, заседает Европарламент, 
        создан Брюссельский Коммуникационный Центр Европейского Эсперантистского Союза. 
        Его цель – защищать языковую демократию и равноправие языков в Европейском Союзе и Европейском Парламенте. 
        Форум для интересующихся проблемами языковой демократии: 
        <a href="http://groups.yahoo.com/group/lingva-demokratio/" target="_blank">http://groups.yahoo.com/group/lingva-demokratio/</a> 
        Адрес Коммуникационного Центра для получения информации, в т. ч. документа «Последние новости об Эсперанто» (Gxisdate pri Esperanto): 
        <a href="mailto:komunikadcentro@esperanto.org" target="_blank">komunikadcentro@esperanto.org</a>
      </p>

      <p class="mb-3">
        В том же Брюсселе ежегодно проводится т.н. «Еврошкола» - 
        ознакомление групп школьников изо всех европейских стран с деятельностью Европарламента и других руководящих учреждений Европейского Союза, 
        с проблемами развития Европы и с европейскими ценностями. 
        С 2001 года в программе Еврошколы участвуют группы юных эсперантистов, в том числе и из стран СНГ. 
        Подробности на сайте: <a href="http://e.euroskola.free.fr" target="_blank">http://e.euroskola.free.fr</a> 
        или в pdf-формате: 
        <a href="http://home.t-online.de/home/esperanto/mee001.pdf" target="_blank">http://home.t-online.de/home/esperanto/mee001.pdf</a>
      </p>

      <p class="mb-3">
        Разумеется, существуют сайты различных Эсперанто-организаций: Всемирной Эсперанто-Ассоциации, 
        Всемирной Молодежной Эсперанто-Организации, профессиональных и национальных Эсперанто-Ассоциаций, 
        отдельных клубов и отдельных эсперантистов. 
        Существуют сайты издательства СД-дисков с записями эсперантских певцов и ансамблей; 
        несколько сетевых библиотек с сотнями названий оригинальных и переведенных книг; 
        сайты, предлагающие «музыку для души» и адреса для переписки. 
        В Сети можно найти перевод на Эсперанто престижного французского журнала “Le Monde Diplomatique” 
        и записи радиопередач 17-ти радиостанций, 
        вещающих на Эсперанто, а также самый большой эсперантский портал ĜANGALO с новостями изо всех стран мира. 
        В скором времени ĜANGALO обещает и телевидение в Интернете на Эсперанто.
      </p>

      <p class="mb-3">
        Как видим, тема «Эсперанто и Интернет» неисчерпаема. 
        Я коснулась слегка, поверхностно, лишь нескольких отдельных её аспектов. 
        Если тема заинтересует читателей, можно углубить и расширить приведенные сведения. 
        Материала хватит по меньшей мере на десяток статей.
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: `Эсперанто и интернет`
}

const itemDate = {
  rus: `2005 год`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemDate: itemDate.rus,
    itemAuthor: author.rus
  }
}

export default item;